
import { css } from 'lit';
export default css`
pc-icon-link{
  display:inline;
  position:relative;
}

  pc-icon-link pc-icon{
    display:inline-flex;
    justify-content:center;
    align-items:center;
    transition:background ease-in 300ms, color ease-in 300ms;
    border:1px solid var(--purple-indigo);
    border-radius:300px;
    background-color:transparent;
    width:40px;
    height:20px;
    color:var(--purple-indigo);
  }

  @media print{

  pc-icon-link pc-icon{
      display:none
  }
    }

  pc-icon-link a:hover pc-icon{
    background:var(--purple-indigo);
    color:var(--primary-white);
  }

pc-icon-link:not([show-label]) a > span{
    clip:rect(0, 0, 0, 0);
    position:absolute;
    margin:-1px;
    border:0;
    padding:0;
    width:1px;
    height:1px;
    overflow:hidden;
  }

@media print{

pc-icon-link:not([show-label]) a > span{
      position:relative;
      color:var(--primary-eggplant);
      font-weight:var(--fw-light)
  }
    }

pc-icon-link:not([show-label]) a:after{
    position:absolute;
    inset:0;
    content:'';
  }

pc-icon-link[show-label]{
  display:inline-block;
}

pc-icon-link[show-label] a{
  text-wrap:balance;
  display:inline-flex;
  gap:var(--spacing-3);
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
  font-family:var(--ff-body);
}

@media (min-width: 768px){

pc-icon-link[show-label] a{
    gap:var(--spacing-4);
    font-size:var(--fs-body);
    line-height:var(--lh-body)
}
  }

@media print{
    pc-icon-link[show-label] a[href^='mailto']{
      color:var(--purple-indigo);
    }
  }

pc-icon-link[show-label] pc-icon{
  flex-shrink:0;
  transform:translateY(1px);
}

@media (min-width: 768px){

pc-icon-link[show-label] pc-icon{
    transform:translateY(3px)
}
  }
`;